<template>
    <div class="content">
        <table border="1" cellspacing="0">
            <colgroup>
                <col style="width:10%">
                <col style="width:10%">
                <col style="width:15%">
                <col style="width:12%">
                <col style="width:16%">
                <col style="width:19%">
                <col style="width:18%">
            </colgroup>
            <tr>
                <td colspan="7" class="table-title">第三方信息共享清单</td>
            </tr>
            <tr>
                <td>功能类型</td>
                <td>第三方名称</td>
                <td>使用目的</td>
                <td>使用场景</td>
                <td>共享方式</td>
                <td>个人信息类型</td>
                <td>第三方隐私政策链接</td>
            </tr>
            <tr>
                <td rowspan="2">支付</td>
                <td>微信支付</td>
                <td>帮助用户在应用内使用微信支付完成会员购买</td>
                <td>用户需要支付费用时</td>
                <td>微信支付SDK本地采集（仅在启动APP、初始化SDK时进行收集）</td>
                <td><b><i>设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息</i></b></td>
                <td>https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2</td>
            </tr>
            <tr>
                <td>支付宝</td>
                <td>帮助用户在应用内使用支付宝支付完成会员购买</td>
                <td>用户需要支付费用时</td>
                <td>支付宝SDK本地采集（仅在启动APP、初始化SDK时进行收集）</td>
                <td><b><i>设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息、传感器、设备序列号、ip地址、运营商信息</i></b></td>
                <td>https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000174</td>
            </tr>
            <tr>
                <td rowspan="2">工具</td>
                <td>Cocos2D-X SDK</td>
                <td>帮助用户使用应用时确认设备稳定</td>
                <td>仅在启动APP、初始化时进行收集</td>
                <td>SDK本地采集</td>
                <td><b><i>设备传感器</i></b></td>
                <td>https://download.cocos.com/CocosUdc/agreement/Cocos_Privacy_Policy_cn_20200904.html</td>
            </tr>
            <tr>
                <td>Chromium SDK</td>
                <td>调用浏览器功能，展示软件的常见问答信息</td>
                <td>用户打开帮助页面等调用浏览器时</td>
                <td>SDK本地采集</td>
                <td><b><i>监听剪切板、获取当前已连接上的wifi的信息、获取SSID信息、获取BSSID信息</i></b></td>
                <td>https://www.chromium.org/Home/chromium-privacy/</td>
            </tr>
        </table>
    </div>
</template>
<script>

export default {
  name: 'privacyThirdParty',
}
</script>
<style src="@/assets/help/document.css" scoped></style>
